import { render, staticRenderFns } from "./ViewPostService.vue?vue&type=template&id=75194398&"
import script from "./ViewPostService.vue?vue&type=script&lang=js&"
export * from "./ViewPostService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports